import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styles from "./Button.css"

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  block: PropTypes.bool,
  loading: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
}

const defaultProps = {
  className: null,
  loading: false,
  color: "default",
  size: null,
  block: false,
  to: null,
  href: null,
}

function Button(props) {
  const { to, href, size, color, block, loading, className, ...rest } = props
  const classes = [styles.root, styles[color] || styles.default]

  if (size) {
    classes.push(styles[size])
  }
  if (loading) {
    classes.push(styles.loading)
  }
  if (block) {
    classes.push(styles.block)
  }
  if (className) {
    classes.push(className)
  }

  if (to) {
    return (
      <Link to={to} {...rest} className={classes.join(" ")}>
        {props.children}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} {...rest} className={classes.join(" ")}>
        {props.children}
      </a>
    )
  }

  return (
    <button type="button" {...rest} className={classes.join(" ")}>
      {props.children}
    </button>
  )
}

Button.propTypes = propTypes
Button.defaultProps = defaultProps

export default Button



// WEBPACK FOOTER //
// ./src/shared/components/Button/Button.js